import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { AuthSelectors, UserInfoSelectors } from 'common/config/store';
import history from 'app-router/history';
import { isEspagne } from 'common/config/env';

export const loginRedirection = ({
  canReadCirculations,
  canReadCustomerFlux,
  canReadHistorisation,
}: {
  canReadCirculations: boolean;
  canReadCustomerFlux: boolean;
  canReadHistorisation: boolean;
}) => {
  if (canReadCirculations) {
    history.push('/circulation');
  } else if (canReadCustomerFlux) {
    if (isEspagne) {
      history.push('/customers/station');
    } else {
      history.push('/customers/OD');
    }
  } else if (canReadHistorisation) {
    history.push('/historisation');
  } else {
    history.push('/users');
  }
};

const loginExpiredRedirection = () => {
  history.push('/update-password');
};

export default function useLoginRedirection() {
  const isAuth = useSelector(AuthSelectors.isAuthSelector);
  const isLoginExpired = useSelector(AuthSelectors.isLoginExpiredSelector);
  const canReadCirculations = useSelector(UserInfoSelectors.hasReadAccess('Circulations'));
  const canReadCustomerFlux = useSelector(UserInfoSelectors.hasReadAccess('Customer-Flux'));
  const canReadHistorisation = useSelector(UserInfoSelectors.hasReadAccess('Historisation'));

  useEffect(() => {
    if (isLoginExpired) {
      loginExpiredRedirection();
    } else if (isAuth) {
      loginRedirection({
        canReadCirculations,
        canReadCustomerFlux,
        canReadHistorisation,
      });
    }
  }, [isAuth, isLoginExpired, canReadCirculations, canReadCustomerFlux, canReadHistorisation]);

  return null;
}
